import type { Level, PublicLevel, RawLevel, Player, DepositBonusesRaw, DepositBonuses, FreeRoundsBonusesRaw, FreeRoundsBonuses } from '@/types';
import { storageDomain } from '@/utils/variables';
import { bonusAdapter } from '@/adapters/bonusAdapter';
import { isDepositBonusWithLimits, isDepositBonusNoLimits } from '@/helpers/bonusesGuards';
export const levelAdapter = {
    mapLevel(level: RawLevel[], player: Player): Level[] {
        const sortedLevels = [...level].sort((a, b) => Number(a.order) - Number(b.order));
        const startLevel = sortedLevels.map((item: RawLevel) => ({
            ...item,
            logo: `https://${storageDomain}/levels/${item.logo}`,
            flip: false,
            current: item.order === player.level.order,
            is_completed: item.order < player.level.order,
            is_locked: item.order > player.level.order,
            next_level_amount: item.next_level_amount[player.currency as keyof typeof item.next_level_amount],
            cost_level_amount: 0,
            cumulative_cost: 0,
            free_rounds_bonus: item.free_rounds_bonus ? getFreeRoundsBonus(item.free_rounds_bonus) : null,
            dep_bonus: item.dep_bonus ? getDepositBonus(item.dep_bonus, player) : null
        }));
        const rd = startLevel;
        rd.forEach((item, index, array) => {
            const costLevelAmount = index > 0 ? array[index - 1].next_level_amount : 0;
            item.cost_level_amount = costLevelAmount;
            const cumulativeCosts = toGetCumulativeCosts(rd);
            item.cumulative_cost = cumulativeCosts[item.order];
        });

        return rd;
    },
    mapPublicLevel(level: RawLevel): PublicLevel {
        return {
            ...level,
            logo: `https://${storageDomain}/levels/${level.logo}`
        };
    }
};
function getDepositBonus(bonus: DepositBonusesRaw, player: Player): DepositBonuses | null {
    if (isDepositBonusWithLimits(bonus)) {
        return bonusAdapter.mapDepositBonusLimits(bonus, player);
    } else if (isDepositBonusNoLimits(bonus)) {
        return bonusAdapter.mapDepositBonusNoLimits(bonus);
    }
    return null;
}
function getFreeRoundsBonus(bonus: FreeRoundsBonusesRaw): FreeRoundsBonuses {
    return bonusAdapter.mapFreeRoundsBonus(bonus);
}
function toGetCumulativeCosts(levels: Level[]) {
    const cumulative: Record<number, number> = {};
    let sum = 0;
    [...levels]
        .sort((a, b) => Number(a.order) - Number(b.order))
        .forEach((level) => {
            sum += level.cost_level_amount || 0;
            cumulative[level.order] = sum;
        });

    return cumulative;
}
